import cn from "app/utils/classnames";
import useGameData from "app/game-data/useGameData";
import { useGameState } from "app/game/useGame";
import MenuButton from "app/ui/MenuButton";
import TypoWord from "app/ui/TypoWord";
import { useKey } from "react-use";
import { useEffect, useState } from "react";

interface NextRoundButtonProps {
  onClick: () => void;
  className?: string;
  allowEnter?: boolean;
}

export default function NextRoundButton(props: NextRoundButtonProps) {
  const gameState = useGameState();
  const data = useGameData();
  const [keyInputAllowed, setKeyInputAllowed] = useState(false);

  // Prevent enter keypress from being recognized on the first frame the button
  // is created. This is to prevent a keypress that entered the current state
  // from triggering the button on the same frame that it's mounted.
  useEffect(() => {
    setKeyInputAllowed(true);
  }, []);

  useKey(
    (event) => event.key === "Enter" && keyInputAllowed,
    () => {
      props.onClick();
    }
  );

  const isFinalRound =
    gameState.roundIndex >= (data?.levels.length ?? Infinity) - 1;

  return (
    <MenuButton className={cn("px-8", props.className)} onClick={props.onClick}>
      {isFinalRound ? (
        <>
          See <TypoWord word="Results" />
        </>
      ) : (
        <>
          <TypoWord word="Next" /> Round
        </>
      )}
    </MenuButton>
  );
}
